export const EMAIL = {
  MIN_LENGTH: 8,
  MAX_LENGTH: 150,
};
export const PASSWORD = {
  MIN_LENGTH: 8,
  MAX_LENGTH: 40,
};
export const FIRST_NAME = {
  MAX_LENGTH: 50,
  MIN_LENGTH: 1,
};
export const LAST_NAME = {
  MAX_LENGTH: 150,
  MIN_LENGTH: 2,
};
export const COMPANY = {
  MAX_LENGTH: 30,
  MIN_LENGTH: 2,
};

export const CITY = {
  MAX_LENGTH: 120,
};
// Название компании корп. клиента — как в модели бэка (CorpClient.company); общий COMPANY.MAX_LENGTH = 30 для юрлиц мал.
export const CORP_COMPANY = {
  MAX_LENGTH: 100,
};
export const TAXPAYER_ID_NUMBER = {
  MIN_LENGTH: 12,
  MAX_LENGTH: 12,
};
export const PHONE_NUMBER = {
  MIN_LENGTH: 5,
  MAX_LENGTH: 22,
};
export const TELEGRAM = {
  MIN_LENGTH: 5,
  MAX_LENGTH: 32,
};
